import styled from 'styled-components';
import { StyledCard } from '../../../components/Card.component';

export const StyledEventsPage = styled.div`
  padding: 22px;

  ${StyledCard} {
    max-height: calc(100vh - 44px - 121px);
    overflow: hidden;
  }
`;
export const StyledTopBarPage = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 24px;
`;
